if (!customElements.get('herbonata-product-share')) {
  customElements.define('herbonata-product-share', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const copy = this.querySelector('[data-copy]');
      const whatsapp = this.querySelector('[data-whatsapp]');
      const status = this.querySelector('[data-status]');
      const fallback = this.querySelector('[data-fallback]');
      const productUrl = () => {
        const url = new URL(this.dataset.url, location.origin);
        const section = this.closest('.sec__main-product');
        const id = section?.querySelector('input[name="id"]')?.value;
        if (id) url.searchParams.set('variant', id);
        return url.toString();
      };
      whatsapp.addEventListener('click', () => {
        whatsapp.href = 'https://wa.me/?text=' + encodeURIComponent(productUrl());
      });
      copy.addEventListener('click', async () => {
        const url = productUrl();
        try {
          await navigator.clipboard.writeText(url);
          copy.textContent = 'Lien copié';
          status.textContent = 'Le lien du produit a été copié.';
          fallback.hidden = true;
        } catch {
          fallback.value = url;
          fallback.hidden = false;
          fallback.focus();
          fallback.select();
          status.textContent = 'Sélectionnez et copiez ce lien.';
        }
      });
    }
  });
}
